import React from 'react';
export function SectionLabel({
  text
}: {
  text: string;
}) {
  return <div className="flex items-center gap-4 mb-6" data-id="element-310">
      <div className="h-[1px] w-8 bg-bio-teal/50" data-id="element-311" />
      <span className="font-mono text-xs text-bio-teal tracking-widest uppercase" data-id="element-312">
        {text}
      </span>
      <div className="h-[1px] flex-1 bg-gradient-to-r from-bio-teal/20 to-transparent" data-id="element-313" />
    </div>;
}